export default __webpack_public_path__ + "static/media/slider03.17713c88.png";